// extracted by mini-css-extract-plugin
module.exports = {"section":"Hero_section__14gi2","container":"Hero_container__VXQEl","body":"Hero_body__1Zqkr","content":"Hero_content__3KmZo","title":"Hero_title__23mC8","text":"Hero_text__1zYcc"};